import { Link } from 'react-router-dom';

import { Facebook, Instagram, Linkedin, Mail, MapPin, Phone } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h3 className="text-xl font-bold mb-4">PRIME JC</h3>
            <p className="text-gray-400">
              Soluciones tecnológicas e industriales para optimizar sus procesos empresariales.
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Contacto</h3>
            <div className="space-y-2">
              <div className="flex items-center">
                <Mail className="h-5 w-5 mr-2" />
                <a
                  href="mailto:contacto@solinprimejc.com"
                  className="text-gray-400 hover:text-white"
                >
                  contacto@solinprimejc.com
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="h-5 w-5 mr-2" />
                <a href="tel:+56984918725" className="text-gray-400 hover:text-white">
                  +56 9 8491 8725
                </a>
              </div>
              <div className="flex items-center">
                <MapPin className="h-5 w-5 mr-2" />
                <span className="text-gray-400">
                  AV. PDTE. KENNEDY 7440 OFICINA 701, VITACURA, SANTIAGO
                </span>
              </div>
            </div>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Enlaces</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/servicios" className="text-gray-400 hover:text-white">
                  Servicios
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-gray-400 hover:text-white">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-gray-400 hover:text-white">
                  Contacto
                </Link>
              </li>
              <li>
                <Link
                  to="/preferencias-de-cookies"
                  className="text-gray-400 hover:text-white cursor-pointer"
                >
                  Preferencias de cookies
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4">Síguenos</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/solinprimejc/?viewAsMember=true"
                className="text-gray-400 hover:text-white"
                aria-label="Visita nuestro perfil de LinkedIn"
              >
                <Linkedin className="h-6 w-6" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61576773628019"
                className="text-gray-400 hover:text-white"
                aria-label="Visita nuestra página de Facebook"
              >
                <Facebook className="h-6 w-6" />
              </a>
              <a
                href="https://www.instagram.com/solinprimejc/"
                className="text-gray-400 hover:text-white"
                aria-label="Visita nuestro perfil de Instagram"
              >
                <Instagram className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-800 text-center">
          <p className="text-gray-400">
            © {new Date().getFullYear()} SOLUCIONES INDUSTRIALES PRIME JC SpA. Todos los derechos
            reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
